module.exports = __webpack_public_path__ + "img/图片5.b5e04be6.png";